import {Template, TemplateConfig} from './types';
import ClassicTemplate from './classic';
import {classicConfig} from './classic/config';
import SplitTemplate from './split';
import {splitConfig} from './split/config';

// Re-export types
export * from './types';
export {useTimeBasedColors, getTimeBasedColors} from './hooks/useTimeBasedColors';

/**
 * Registry of all available templates
 */
const templates: Template[] = [
  {
    ...classicConfig,
    component: ClassicTemplate,
  },
  {
    ...splitConfig,
    component: SplitTemplate,
  },
];

/**
 * Get a template by its ID
 * @param id - The template ID to look up
 * @returns The template if found, or the default (classic) template
 */
export function getTemplate(id: string): Template {
  const template = templates.find(t => t.id === id);
  return template || templates[0]; // Default to classic
}

/**
 * Get all available templates
 * @returns Array of all registered templates
 */
export function getAllTemplates(): Template[] {
  return templates;
}

/**
 * Get template configs only (without components, for listing)
 * @returns Array of template configurations
 */
export function getAllTemplateConfigs(): TemplateConfig[] {
  return templates.map(({id, name, description, thumbnail}) => ({
    id,
    name,
    description,
    thumbnail,
  }));
}

/**
 * Check if a template ID exists
 * @param id - The template ID to check
 * @returns true if the template exists
 */
export function templateExists(id: string): boolean {
  return templates.some(t => t.id === id);
}

/**
 * Get the default template ID
 */
export const DEFAULT_TEMPLATE_ID = 'classic';

export default {
  getTemplate,
  getAllTemplates,
  getAllTemplateConfigs,
  templateExists,
  DEFAULT_TEMPLATE_ID,
};
